export enum AnalyticsDurationIdentifier {
  Effective = 'Effective',
  Modified = 'Modified'
}

export interface DealAnalytics {
  maturities: MaturityAnalytics[];
}

export interface MaturityAnalytics {
  cusip: string;
  effectiveConvexity: number;
  effectiveDuration: number;
  id: string;
  modifiedConvexity: number;
  modifiedDuration: number;
  oas: number;
  zSpread: number;
}

export interface MaturityCouponOverrides {
  [maturityId: string]: number;
}
export interface Call {
  i_date: string;
  price: number;
}
export interface SinkingFunds {
  amount: number;
  m_date: string;
  price: number;
}

export interface OASMaturities {
  coupon: number;
  face_amount: number;
  i_date: string;
  m_date: string;
  name: string;
  price: number;
  calls?: Call[];
  sinking_funds?: SinkingFunds[];
}
